import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface TournamentRules {
  playersPerGroup: number;
  qualifiersPerGroup: number;
  minGroups: number;
  nextPhase: string;
}

export const useTournamentRules = (eventId: string) => {
  const [rules, setRules] = useState<TournamentRules | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchTournamentRules = async () => {
      try {
        setLoading(true);
        setError(null);

        const { data: event, error: eventError } = await supabase
          .from('events')
          .select('rules')
          .eq('id', eventId)
          .single();

        if (eventError) {
          throw eventError;
        }

        if (event?.rules) {
          try {
            const parsedRules = JSON.parse(event.rules);
            setRules(parsedRules);
          } catch (parseError) {
            console.error('Error parsing tournament rules:', parseError);
            // Set default rules if parsing fails
            setRules({
              playersPerGroup: 3,
              qualifiersPerGroup: 2,
              minGroups: 8,
              nextPhase: 'octavos'
            });
          }
        } else {
          // Default rules if no rules found
          setRules({
            playersPerGroup: 3,
            qualifiersPerGroup: 2,
            minGroups: 8,
            nextPhase: 'octavos'
          });
        }
      } catch (err) {
        console.error('Error fetching tournament rules:', err);
        setError(err instanceof Error ? err.message : 'Error desconocido');
        // Set default rules on error
        setRules({
          playersPerGroup: 3,
          qualifiersPerGroup: 2,
          minGroups: 8,
          nextPhase: 'octavos'
        });
      } finally {
        setLoading(false);
      }
    };

    if (eventId) {
      fetchTournamentRules();
    }
  }, [eventId]);

  return { rules, loading, error };
};